import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import { initPostHog } from "./lib/analytics.ts";
import "./index.css";

// ─── Sentry (error monitoring + performance) ─────────────────────────────────
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,   // FERPA safety
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 0,   // 20% of prod transactions
    replaysSessionSampleRate: 0.05,                       // 5% of sessions
    replaysOnErrorSampleRate: 1.0,                        // 100% on error
  });
}

// ─── PostHog (product analytics) ─────────────────────────────────────────────
initPostHog();

createRoot(document.getElementById("root")!).render(<App />);
